import { HttpErrorResponse } from '@angular/common/http';
import { computed, inject } from '@angular/core';
import {
  patchState,
  signalStore,
  withComputed,
  withMethods,
  withState,
} from '@ngrx/signals';
import {
  ManagementService,
  ReaderPricesUpdateStatus,
} from '@thiememeulenhoff/ng-api-gateway';
import { firstValueFrom } from 'rxjs';
import { withRequestStatus } from '../_utils/request-status.feature';

export const ManagementReaderPricesStore = signalStore(
  withState({ status: null as ReaderPricesUpdateStatus }),
  withRequestStatus(),
  withComputed(({ status, isLoaded }) => ({
    canUpdate: computed(() => isLoaded() && status() !== 'running'),
  })),
  withMethods((store, managementService = inject(ManagementService)) => ({
    async refreshStatus() {
      if (store.isLoading()) return;
      patchState(store, { requestStatus: 'loading' });
      try {
        const { status } = await firstValueFrom(
          managementService.fetchReaderPricesUpdateStatus(),
        );
        patchState(store, { status, requestStatus: 'success' });
      } catch {
        patchState(store, { requestStatus: { error: 'status' } });
      }
    },

    async startUpdate() {
      if (!store.canUpdate()) return;
      patchState(store, { requestStatus: 'loading' });
      try {
        const { status } = await firstValueFrom(
          managementService.updateReaderPrices(),
        );
        patchState(store, { status, requestStatus: 'success' });
      } catch (error: unknown) {
        if (error instanceof HttpErrorResponse && error.status === 409) {
          patchState(store, { status: 'running', requestStatus: 'success' });
        } else {
          patchState(store, { requestStatus: { error: 'start' } });
        }
      }
    },
  })),
);
